const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
var rID = urlParams.get("responseId");
var recomndedProductId;
var recomndedProductName;

if (rID) {
  localStorage.setItem("responseId", rID);
} else {
  rID = localStorage.getItem("responseId");
}

var endPoint = {
  dev: "https://dev.thegoodbug.com/v1.0/gb-diagnosis/",
  prod: "https://tgbapi.thegoodbug.com/v1.0/gb-diagnosis/",
};
var token = {
  dev: "Bearer 18393c7b-4abe-4459-8bc6-93496b0c66e3",
  prod: "Bearer 18393c7b-4abe-4459-8bc6-93496b0c66e3",
};
var env = "prod";

if (!rID) {
  const urlString = window.location.href;
  const queryString = urlString.split('?')[1];
  if (queryString === undefined){
    alert("Take Hair Test");
    window.location.href = "/";
  }else{
    window.location.href = `/?${queryString}`;
  }
} else {
  fetch(`${endPoint[env]}/?responseId=${rID}`, {
    method: "GET",
    headers: {
      Authorization: `${token[env]}`,
    },
  }).then((response) => {
    return response.json();
  }).then((result) => {
    const { standard_products, recommended_products } = result;
    var standard_product_lists = [], recommended_product_lists = [];
    standard_product_lists.push(`/products/bye-bye-bloat?variant=43746753118433&view=result-product`);
    if(standard_products.length != 0) {
    recomndedProductId = recommended_products?.[1]?.product_id;
    recomndedProductName = recommended_products?.[1]?.product_name;
      standard_products.forEach((product) => {
        if(product.product_handle !== "undefined" && product.product_id !== "undefined") {
          var url = `/products/${product.product_handle}?variant=${product.product_id}&view=result-product`;
          standard_product_lists.push(url);
        }
      });
    }
    standard_product_lists.forEach(async (product) => {
      // console.log('product', product)
      await product_list(product, 'standard');
    })
    if(recommended_products.length != 0) {
      recommended_products.forEach((product) => {
        if(product.product_handle !== undefined && product.product_id !== undefined) {
          var url = `/products/${product.product_handle}?variant=${product.product_id}&view=result-product`;
          recommended_product_lists.push(url);
        }
      })
    }else if(recommended_products.length == 0) {
      var recommededProductCard = document.querySelectorAll('[recommededproductcard]');
      if(recommededProductCard.length != 0) {
        recommededProductCard.forEach((card) => {
          card.style.display = 'none';
        })
      }
    }
    if(recommended_product_lists.length != 0) {
      recommended_product_lists.forEach(async (product) => {
        await product_list(product, 'recommendation');
      })
    }
    $('[username]').text(result?.user?.name);
    $('[userage]').text(result?.user?.age);
    $('[usersex]').text(result?.user?.sex);
    $('[userheight]').text(result?.diagnosis?.current_status?.height);
    $('[userwaist]').text(result?.diagnosis?.current_status?.waist_size);
    $('[userdiet]').text(result?.diagnosis?.current_status?.diet);
    $('[weight]').text(result?.diagnosis?.current_status?.weight);
    $('[bodymassindex]').text(result?.diagnosis?.current_status?.body_mass_index);
    $('[waisttoheightratio]').text(result?.diagnosis?.current_status?.waist_to_height_ratio);
    $('[overallhealthscore]').text(result?.diagnosis?.current_health_score?.overall_health_score);  
    $('[digestivehealthscore]').text(result?.diagnosis?.current_health_score?.digestive_health_score);  
    $('[metabolichealthscore]').text(result?.diagnosis?.current_health_score?.metabolic_health_score); 
    $('[mentalhealthscore]').text(result?.diagnosis?.current_health_score?.mental_health_score);
    $('[formfilleddate]').text(result?.form_filled_date);
    $('[targetweight]').text(result?.diagnosis?.weight_loss_goal?.target_weight);
    $('[targettime]').text(result?.diagnosis?.weight_loss_goal?.target_time);
    $('[targetbmi]').text(result?.diagnosis?.weight_loss_goal?.target_bmi);
  
    let weight = Number(result?.diagnosis?.current_status?.weight);
    let body_mass_index = Number(result?.diagnosis?.current_status?.body_mass_index)-20;
    let waist_to_height_ratio = Number(result?.diagnosis?.current_status?.waist_to_height_ratio)+20;
    let overall_health_score = Number(result?.diagnosis?.current_health_score?.overall_health_score);
    let digestive_health_score = Number(result?.diagnosis?.current_health_score?.digestive_health_score);
    let metabolic_health_score = Number(result?.diagnosis?.current_health_score?.metabolic_health_score);
    let mental_health_score = Number(result?.diagnosis?.current_health_score?.mental_health_score);
    let target_weight = Number(result?.diagnosis?.weight_loss_goal?.target_weight);
    let targetTimeString = result?.diagnosis?.weight_loss_goal?.target_time;
    console.log('targetTimeString', targetTimeString);
    let target_time =   Math.floor(Number(result?.diagnosis?.weight_loss_goal?.target_time));
    let target_bmi = Number(result?.diagnosis?.weight_loss_goal?.target_bmi)-30;
    var counterElements = document.querySelectorAll('[data-counter]');
    var counter = 0;
    var targetCounter = weight;
    function updateCounter() {
      if (counter >= targetCounter) {
        clearInterval(counterInterval);
      }else {
        counter++;
        counterElements.forEach(function (element) {
          element.textContent = counter;
        });
      }
    }
    
    var counterInterval = setInterval(updateCounter, 10);
    var massIndexElements = document.querySelector('[body-mass-index]');
    if(massIndexElements) {
      massIndexElements.style.transform = `rotate(${body_mass_index}deg)`;
    };
    var heightIndexElements = document.querySelector('[body_height]');
    if(heightIndexElements) {
      heightIndexElements.style.transform = `rotate(${waist_to_height_ratio}deg)`;
    };
    var targetBmiElements = document.querySelector('[target_bmi]');
    if(targetBmiElements) {
      targetBmiElements.style.transform = `rotate(${target_bmi}deg)`;
    };   
 // counter-max-NaN 23/01/24 
     function updateScoreCounter(elements, counter, targetCounter, interval) {
        var counterInterval = setInterval(function () {
          if (isNaN(counter) || counter >= targetCounter || counter > 100) {
            clearInterval(counterInterval);
            counter = Math.min(counter || 0, 100); 
          } else {
            counter++;
            elements.forEach(function (element) {
              element.textContent = counter + (interval ? '%' : '');
            });
          }
        }, 10);
      }
    var overallHealthScoreElements = document.querySelectorAll('[overall_health_score]');
    updateScoreCounter(overallHealthScoreElements, 0, overall_health_score, true);
    
    var digestiveHealthScoreElements = document.querySelectorAll('[digestive_health_score]');
    updateScoreCounter(digestiveHealthScoreElements, 0, digestive_health_score, true);
    
    var metabolicHealthScoreElements = document.querySelectorAll('[metabolic_health_score]');
    updateScoreCounter(metabolicHealthScoreElements, 0, metabolic_health_score, true);
    
    var mentalHealthScoreElements = document.querySelectorAll('[mental_health_score]');
    updateScoreCounter(mentalHealthScoreElements, 0, mental_health_score, true);
    
    var targetWeightScoreElements = document.querySelectorAll('[target_weight]');
    updateScoreCounter(targetWeightScoreElements, 0, target_weight);
    
    var targetTimeScoreElements = document.querySelectorAll('[target_time]');
    updateScoreCounter(targetTimeScoreElements, 0, target_time);
  
    const fillSpan = document.querySelector('.fill');
    const valueSpans = document.querySelectorAll('.value');
    const animationDuration = 8;
  
    let keyframesName;
    if (overall_health_score < 50) {
      keyframesName = 'moveAnimation550';
    } else if (overall_health_score >= 51 && overall_health_score <= 60) {
      keyframesName = 'moveAnimation400';
    } else if (overall_health_score >= 61 && overall_health_score <= 70) {
      keyframesName = 'moveAnimation300';
    } else if (overall_health_score >= 71 && overall_health_score <= 80) {
      keyframesName = 'moveAnimation250';
    } else if (overall_health_score >= 81 && overall_health_score <= 100) {
      keyframesName = 'moveAnimation100';
    }
  
    fillSpan.style.animation = `${keyframesName} ${animationDuration}s forwards`;
    fillSpan.addEventListener('animationend', () => {
      valueSpans.forEach(valueSpan => {
        valueSpan.textContent = `${overall_health_score}%`;
      });
    });
  // graph
    var dateOnly = (result?.form_filled_date || '').split('T')[0];
    $('[formfilleddate]').text(dateOnly);
    const formFilledDate = new Date(dateOnly);
    const targetTime = 3;
    
    const xValues = [];
    for (let i = 0; i <= targetTime; i++) {
      const date = new Date(formFilledDate);
      date.setMonth(formFilledDate.getMonth() + i);
      const month = date.toLocaleString('default', { month: 'short' });
      xValues.push(month);
    }
    target_weight = Math.ceil(target_weight);
    const weightDifference = target_weight - weight;
    const yValues = [];
    for (let i = 0; i <= targetTime; i++) {
      const value = weight + (weightDifference / targetTime) * i;
      yValues.push(value);
    }
    new Chart("myChart", {
      type: "line",
      data: {
        labels: xValues,
        datasets: [
          {
            data: yValues,
            fill: true,
            backgroundColor: "#e9f8ff",
            borderColor: "#32B1B3",
            pointBackgroundColor: ["#EA5D47", "#32B1B3", "#32B1B3", "#32B1B3"],
            pointBorderColor: "#fff",
            pointRadius: [8, 0, 0, 8],
          },
          {
            data: [],
            borderColor: "green",
            fill: false,
          },
        ],
      },
      options: {
        legend: { display: false },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    });
  }).catch((error) => {
     console.log('error', error);
  });
}

window.checkout = function checkout() {
  var formdata = {
    'items': variant_ids
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: "application/json",
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((response) => {
    window.location.href = '/checkout';
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

// Add to bag function
window.addToBag = function addToBag() {
  var formdata = {
    'items': variant_ids
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: "application/json",
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((response) => {
    
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

// Direct Checkout function
window.directCheckout = function directCheckout(){
  var variants = '';
  variant_ids.forEach((variant, index) => {
    variants = `${variants}${variant.id}:${variant.quantity}${index == variant_ids.length - 1 ? '' : ','}`;
  });
  window.location.href = `/cart/${variants}`;
}

var price = 0, compare_at_price = 0, consultFee = 100000, dietFee = 50000, coachFee = 50000, variant_ids = [];

async function product_list(url, type) {
  await fetch(url).then((response) => {
    return response.text();
  }).then((response) => {
    if(type === 'standard') {
      var target = document.querySelector('.goalUL');
      var product_card = new DOMParser().parseFromString(response, 'text/html')?.querySelector('[result-product]');
      if(target && product_card) {
        target.append(product_card);
        var pd_price = parseInt(product_card.getAttribute('product_price'));
        var pd_cmp_price = parseInt(product_card.getAttribute('compare_at_price'));
        var variant_id = product_card.getAttribute('variant-id');
        if(variant_id != null || variant_id != '') {
          variant_ids.push({
            'id': variant_id,
            'quantity': 1
          });
        }
        price += pd_price;
        compare_at_price += pd_cmp_price;
        var totalFee = price + consultFee + dietFee + coachFee;
        var totalCompareFee = compare_at_price + consultFee + dietFee + coachFee;
        var totalSaving = totalCompareFee - price;
        var allRealPrice = document.querySelector('[allRealPrice]'), allComparePrice = document.querySelector('[allComparePrice]'),
        allTotalCompareFee = document.querySelector('[allTotalCompareFee]'), allTotalFee = document.querySelector('[allTotalFee]'),
        totalSavingFee = document.querySelector('[totalSaving]');
        if(allRealPrice) {
          allRealPrice.innerHTML = `₹${price/100}`;
        }
        if(allComparePrice) {
          allComparePrice.innerHTML = `₹${compare_at_price/100}`;
        }
        if(allTotalCompareFee) {
          allTotalCompareFee.innerHTML = `₹${totalCompareFee/100}`;
        }
        if(allTotalFee) {
          allTotalFee.innerHTML = `₹${price/100}`;
        }
        if(totalSavingFee) {
          totalSavingFee.innerHTML = `You Saved ₹${totalSaving/100}`
        }
      }
    }else if(type === 'recommendation') {
      var target = document.querySelector('.recommended_product_container');
      var product_card = new DOMParser().parseFromString(response, 'text/html')?.querySelector('[recommended-product]');
      // if(target && product_card) {
      //   target.innerHTML = product_card.innerHTML;
      // }


        if(target && product_card) {
        target.innerHTML = product_card.innerHTML;
        const addRecommendedProductBtn = document.getElementById('atcRecommended_product');
        const tableContainer = document.querySelector('.tableContainer');
        const priceContainer = document.querySelector('.mobileAtc').innerHTML;
        console.log("priceContainer",priceContainer);
        let rpContainer = document.createElement('div');
        rpContainer.innerHTML = `<div class="Treatment_GoalwithAmount addedProduct">
          <table class="planTable">
            <tbody>
              <tr class="tableRow">
                <td class="planNumber">5</td>
                <td class="planName planName-7">${recomndedProductName}</td>
                <td style="display: flex;justify-content: space-between;align-items: center;margin: auto;">${priceContainer}</td>
              </tr>
            </tbody>
          </table>
        </div>`;
        
        console.log("daddRecommendedProductBtn",addRecommendedProductBtn);
        addRecommendedProductBtn.addEventListener("click", function() {
          ATCrecomndedProduct(recomndedProductId);
          console.log("variant_ids 354", variant_ids);
          addRecommendedProductBtn.innerText = 'Product Added'
          addRecommendedProductBtn.disabled = true;
          addRecommendedProductBtn.style.backgroundColor = '#004400';
          });
        
            function ATCrecomndedProduct(id) {
            variant_ids.push({
              'id': id,
              'quantity': 1
            });
        const lastChild = tableContainer.lastElementChild;
        console.log("lastChild",lastChild);
        if (lastChild) {
          tableContainer.insertBefore(rpContainer, lastChild);
        } else {
          tableContainer.appendChild(rpContainer);
        }
          }

            }
      
    }
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

// var counterElements = document.querySelectorAll('[data-counter]');
// var counter = 0;
// var targetCounter = 75;

// function updateCounter() {
//   if (counter >= targetCounter) {
//     clearInterval(counterInterval);
//   } else {
//     counter++;
//     counterElements.forEach(function (element) {
//     element.textContent = counter;
//   });
//   }
// }
// var counterInterval = setInterval(updateCounter, 10);

$( document ).ready(function() {
  $('.owl-carousel.doctorsCardWrapper').owlCarousel({
    nav:false,
    dots:false,
    margin:0,
    responsiveClass:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });
  $('.owl-carousel.reviewsCardWrapper').owlCarousel({
    nav:false,
    dots:false,
    margin:0,
    responsiveClass:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3.5
      }
    }
  });
});